import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5295eafc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-bar-secondary" }
const _hoisted_2 = { class: "filter-bar-active-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "del" }, "×", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.urlParam.length > 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
                'filter-bar-active',
                _ctx.tsMobileView
                    ? 'filter-bar-active-mobile'
                    : 'filter-bar-active-desktop',
            ])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "filter-rule",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeParamFilter()))
            }, [
              _createTextVNode(_toDisplayString(_ctx.formatLabel(_ctx.urlParam)) + " ", 1),
              _hoisted_3
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}